var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10452",
    "data-name": "Group 10452",
    transform: "translate(-148 -2745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    transform: "translate(148 2745)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_trend-up",
    "data-name": "vuesax/outline/trend-up",
    transform: "translate(-447.068 2581.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trend-up",
    transform: "translate(620 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.032,8.971a1.024,1.024,0,0,1-.732-.3A1.042,1.042,0,0,1,.3,7.2L4.719,2.786a1.023,1.023,0,0,1,.828-.3,1.035,1.035,0,0,1,.759.456L7.811,5.2l4.9-4.9a1.035,1.035,0,0,1,1.464,1.464l-5.8,5.8a1.023,1.023,0,0,1-.828.3,1.035,1.035,0,0,1-.759-.456l-1.5-2.264L1.764,8.667A1.024,1.024,0,0,1,1.032,8.971Z",
    transform: "translate(9.323 12.085)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.8,4.832A1.043,1.043,0,0,1,2.761,3.8V2.071H1.036A1.043,1.043,0,0,1,0,1.036,1.043,1.043,0,0,1,1.036,0H3.8A1.043,1.043,0,0,1,4.832,1.036V3.8A1.043,1.043,0,0,1,3.8,4.832Z",
    transform: "translate(18.985 12.081)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M18.985,29.685H10.7c-7.5,0-10.7-3.2-10.7-10.7V10.7C0,3.2,3.2,0,10.7,0h8.284c7.5,0,10.7,3.2,10.7,10.7v8.284C29.685,26.482,26.482,29.685,18.985,29.685ZM10.7,2.071c-6.365,0-8.629,2.264-8.629,8.629v8.284c0,6.365,2.264,8.629,8.629,8.629h8.284c6.365,0,8.629-2.264,8.629-8.629V10.7c0-6.365-2.264-8.629-8.629-8.629Z",
    transform: "translate(1.726 1.726)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H33.137V33.137H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart2);
export default __webpack_public_path__ + "static/media/chart2.f8795fd0ece9a8ae5bfe4346d7d02281.svg";
export { ForwardRef as ReactComponent };